import { useMutation } from 'react-fetching-library';

const submitFormAction = ({ accountId, formValues }) => ({
  method: 'POST',
  endpoint: `/api/donate/accounts/${accountId}/mass-offerings`,
  body: formValues,
});

export const useSubmitMassOffering = () => {
  const { loading, payload, mutate, error, errorObject } = useMutation(submitFormAction);

  return { loading, payload, mutate, error, errorObject };
};
